module.exports = __webpack_public_path__ + "img/jm.dbd32e55.svg";